export const asciiCharsRegExp = /^[\x20-\x7E]+$/;
